const REQUEST_LOGIN = 'REQUEST_LOGIN'
const REQUEST_LOGOUT = 'REQUEST_LOGOUT'

const REQUEST_CATEGORIES = 'REQUEST_CATEGORIES'

const REQUEST_REGISTER = 'REQUEST_REGISTER'
const REQUEST_REGISTERED = 'REQUEST_REGISTERED'

const REQUEST_USER_INFO = 'REQUEST_USER_INFO'
const CHANGE_USER_INFO = 'REQUEST_USER_INFO'

const OPEN_LANGUAGE = 'OPEN_LANGUAGE'
const CLOSE_LANGUAGE = 'CLOSE_LANGUAGE'
const ACTIVE_LANGUAGE = 'ACTIVE_LANGUAGE'

const SEND_MAIL = 'SEND_MAIL'

const CHANGE_ROUTE = 'CHANGE_ROUTE'

const OPEN_MENU = 'OPEN_MENU'
const CLOSE_MENU = 'CLOSE_MENU'

const SWITCH_PREVIEW = 'SWITCH_PREVIEW'

const SET_EDITOR_SELECTED_PAGE = 'SET_EDITOR_SELECTED_PAGE'
const SET_EDITOR_PREVIOUS_PAGE = 'SET_EDITOR_PREVIOUS_PAGE'
const ADD_EDITOR_PAGE = 'ADD_EDITOR_PAGE'
const REMOVE_EDITOR_PAGE = 'REMOVE_EDITOR_PAGE'
const SET_EDITOR_ACTIVE = 'SET_EDITOR_ACTIVE'

const CHANGE_TEMPLATE = 'CHANGE_TEMPLATE'
const STARTED_TEMPLATE = 'STARTED_TEMPLATE'

const CHANGE_TEMPLATE_NAVIGATION = 'CHANGE_TEMPLATE_NAVIGATION'
const CHANGE_TEMPLATE_INDEX = 'CHANGE_TEMPLATE_INDEX'
const CHANGE_TEMPLATE_DIVS = 'CHANGE_TEMPLATE_DIVS'

const ADD_HOVERED_CELL = 'ADD_HOVERED_CELL'
const REMOVE_HOVERED_CELL = 'REMOVE_HOVERED_CELL'

const ADD_SELECTED_CELL = 'ADD_SELECTED_CELL'
const REMOVE_SELECTED_CELL = 'REMOVE_SELECTED_CELL'

const UNSELECT_SELECTED_CELL = 'UNSELECT_SELECTED_CELL'

/* ROW */
const INCREASE_ROWS = 'INCREASE_ROWS'
const DECREASE_ROWS = 'DECREASE_ROWS'
const ADD_SELECTED_ROW = 'ADD_SELECTED_ROW'
const REMOVE_SELECTED_ROW = 'REMOVE_SELECTED_ROW'
const DELETE_SELECTED_ROW = 'DELETE_SELECTED_ROW'

/* COLUMN */
const INCREASE_COLUMNS = 'INCREASE_COLUMNS'
const DECREASE_COLUMNS = 'DECREASE_COLUMNS'
const ADD_SELECTED_COLUMN = 'ADD_SELECTED_COLUMN'
const REMOVE_SELECTED_COLUMN = 'REMOVE_SELECTED_COLUMN'
const DELETE_SELECTED_COLUMN = 'DELETE_SELECTED_COLUMN'

const CHANGE_TABLE_NAVIGATION = 'CHANGE_TABLE_NAVIGATION'
const CHANGE_TABLE_NEGATIVE_NAVIGATION = 'CHANGE_TABLE_NEGATIVE_NAVIGATION'
const CHANGE_TABLE_PAGE_SELECTION = 'CHANGE_TABLE_PAGE_SELECTION'
const CHANGE_TABLE_NEGATIVE_PAGE_SELECTION = 'CHANGE_TABLE_NEGATIVE_PAGE_SELECTION'

const ADD_BORDER_LEFT = 'ADD_BORDER_LEFT'
const REMOVE_BORDER_LEFT = 'REMOVE_BORDER_LEFT'

const ADD_BORDER_RIGHT = 'ADD_BORDER_RIGHT'
const REMOVE_BORDER_RIGHT = 'REMOVE_BORDER_RIGHT'

const ADD_BORDER_TOP = 'ADD_BORDER_TOP'
const REMOVE_BORDER_TOP = 'REMOVE_BORDER_TOP'

const ADD_BORDER_BOTTOM = 'ADD_BORDER_BOTTOM'
const REMOVE_BORDER_BOTTOM = 'REMOVE_BORDER_BOTTOM'

const ADD_BORDER = 'ADD_BORDER'
const REMOVE_BORDER = 'REMOVE_BORDER'

const ADD_SPAN = 'ADD_SPAN'
const REMOVE_SPAN = 'REMOVE_SPAN'

const ADD_TEXT = 'ADD_TEXT'
const REMOVE_TEXT = 'REMOVE_TEXT'

const ADD_IMAGE = 'ADD_IMAGE'
const REMOVE_IMAGE = 'REMOVE_IMAGE'

const ADD_MEDIA = 'ADD_MEDIA'
const UPDATE_MEDIA = 'UPDATE_MEDIA'
const REMOVE_MEDIA = 'REMOVE_MEDIA'

const ADD_VIDEO = 'ADD_VIDEO'
const REMOVE_VIDEO = 'REMOVE_VIDEO'

const ADD_SKIP = 'ADD_SKIP'
const REMOVE_SKIP = 'REMOVE_SKIP'

const NEW_TEMPLATE = 'NEW_TEMPLATE'

const CHANGE_PREVIEW = 'CHANGE_PREVIEW'

const RESIZE = 'RESIZE'

const CHANGE_DETAILS = 'CHANGE_DETAILS'
const CHANGE_DETAILS_ORIENTATION = 'CHANGE_DETAILS_ORIENTATION'

const SET_WIDTH = 'SET_WIDTH'
const SET_HEIGHT = 'SET_HEIGHT'

const CHANGE_MODAL = 'CHANGE_MODAL'

const ADD_PAGE = 'ADD_PAGE'
const CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE'
const CHANGE_PREVIOUS_PAGE = 'CHANGE_PREVIOUS_PAGE'
const REMOVE_PAGE = 'REMOVE_PAGE'

const CHANGE_SPACING = 'CHANGE_SPACING'
const CHANGE_SPACING_MARGIN = 'CHANGE_SPACING_MARGIN'

const CHANGE_CONTEXT_MENU = 'CHANGE_CONTEXT_MENU'
const CHANGE_TEXT_CONTEXT_MENU = 'CHANGE_TEXT_CONTEXT_MENU'

const CHANGE_ICON_HOVER = 'CHANGE_ICON_HOVER'

const ADD_EDIT_CELL = 'ADD_EDIT_CELL'
const REMOVE_EDIT_CELL = 'REMOVE_EDIT_CELL'

const ADD_PREVIEW_CELL = 'ADD_PREVIEW_CELL'
const REMOVE_PREVIEW_CELL = 'REMOVE_PREVIEW_CELL'

const PAGE_SWAP = 'PAGE_SWAP'
const PAGE_REARRANGE = 'PAGE_REARRANGE'

const SET_INPUT_TEXT = 'SET_INPUT_TEXT'

const SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH'
const SET_SCREEN_HEIGHT = 'SET_SCREEN_HEIGHT'
const SET_INNER_WIDTH = 'SET_INNER_WIDTH'
const SET_INNER_HEIGHT = 'SET_INNER_HEIGHT'

const actionTypes = {
	/* PAGE */
	ADD_PAGE,
	CHANGE_CURRENT_PAGE,
	CHANGE_PREVIOUS_PAGE,
	REMOVE_PAGE,

	/* INPUT TEXT */
	SET_INPUT_TEXT,

	/* SWAP */
	PAGE_SWAP,

	/* REARRANGE */
	PAGE_REARRANGE,

	/* ICON HOVER */
	CHANGE_ICON_HOVER,

	/* EDIT */
	ADD_EDIT_CELL,
	REMOVE_EDIT_CELL,

	/* PREVIEW */
	ADD_PREVIEW_CELL,
	REMOVE_PREVIEW_CELL,

	/* CONTEXT MENU */
	CHANGE_CONTEXT_MENU,
	CHANGE_TEXT_CONTEXT_MENU,
	
	/* MODAL */
	CHANGE_MODAL,
	
	/* WIDTH */
	SET_WIDTH,

	/* HEIGHT */
	SET_HEIGHT,

	/* DETAILS */
	CHANGE_DETAILS,
	CHANGE_DETAILS_ORIENTATION,

	/* RESIZE */
	RESIZE,

	/* TEMPLATE */
	NEW_TEMPLATE,

	/* PREVIEW */
	CHANGE_PREVIEW,

	/* MEDIA */
	ADD_MEDIA,
	UPDATE_MEDIA,
	REMOVE_MEDIA,

	/* TEXT */
	ADD_TEXT,
	REMOVE_TEXT,

	/* IMAGE */
	ADD_IMAGE,
	REMOVE_IMAGE,

	/* VIDEO */
	ADD_VIDEO,
	REMOVE_VIDEO,

	/* COLUMN */
	ADD_SELECTED_COLUMN,
	REMOVE_SELECTED_COLUMN,
	DELETE_SELECTED_COLUMN,

	/* ROW */
	ADD_SELECTED_ROW,
	REMOVE_SELECTED_ROW,
	DELETE_SELECTED_ROW,

	/* MENU */
	SET_SCREEN_WIDTH,
	SET_SCREEN_HEIGHT,
	SET_INNER_WIDTH,
	SET_INNER_HEIGHT,

	REQUEST_LOGIN,
	REQUEST_LOGOUT,
	REQUEST_CATEGORIES,
	REQUEST_USER_INFO,
	CHANGE_USER_INFO,
	SEND_MAIL,
	CHANGE_ROUTE,
	OPEN_MENU,
	CLOSE_MENU,
	SWITCH_PREVIEW,
	SET_EDITOR_SELECTED_PAGE,
	SET_EDITOR_PREVIOUS_PAGE,
	ADD_EDITOR_PAGE,
	REMOVE_EDITOR_PAGE,
	SET_EDITOR_ACTIVE,
	REQUEST_REGISTER,
	REQUEST_REGISTERED,
	OPEN_LANGUAGE,
	CLOSE_LANGUAGE,
	ACTIVE_LANGUAGE,
	CHANGE_TEMPLATE,
	STARTED_TEMPLATE,
	CHANGE_TEMPLATE_NAVIGATION,
	CHANGE_TEMPLATE_INDEX,
	CHANGE_TEMPLATE_DIVS,
	ADD_HOVERED_CELL,
	REMOVE_HOVERED_CELL,
	ADD_SELECTED_CELL,
	REMOVE_SELECTED_CELL,
	INCREASE_ROWS,
	DECREASE_ROWS,
	INCREASE_COLUMNS,
	DECREASE_COLUMNS,
	CHANGE_TABLE_NAVIGATION,
	CHANGE_TABLE_NEGATIVE_NAVIGATION,
	CHANGE_TABLE_PAGE_SELECTION,
	CHANGE_TABLE_NEGATIVE_PAGE_SELECTION,

	/* SPACING */
	CHANGE_SPACING,
	CHANGE_SPACING_MARGIN,

	/* BORDERS */
	ADD_BORDER_LEFT,
	REMOVE_BORDER_LEFT,
	ADD_BORDER_RIGHT,
	REMOVE_BORDER_RIGHT,
	ADD_BORDER_TOP,
	REMOVE_BORDER_TOP,
	ADD_BORDER_BOTTOM,
	REMOVE_BORDER_BOTTOM,
	ADD_BORDER,
	REMOVE_BORDER,

	/* END BORDERS */

	UNSELECT_SELECTED_CELL,
	REMOVE_SPAN,
	ADD_SPAN,
	REMOVE_SKIP,
	ADD_SKIP
}

export default actionTypes;